export const lireEnBase64 = (fichier) => new Promise((resoudre, rejeter) => {
  const lecteur = new FileReader();
  lecteur.onload = () => resoudre(String(lecteur.result).split(',')[1] || '');
  lecteur.onerror = () => rejeter(lecteur.error);
  lecteur.readAsDataURL(fichier);
});
